import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const DirectionHorizontal = (props: SvgProps) => (
  <Svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 1.5H2.5C1.94772 1.5 1.5 1.94772 1.5 2.5V9.5C1.5 10.0523 1.94772 10.5 2.5 10.5H9.5C10.0523 10.5 10.5 10.0523 10.5 9.5V2.5C10.5 1.94772 10.0523 1.5 9.5 1.5Z"
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 4.16129V8.03226M3 7.25806V4.93548M9 9V3M3 9V3"
      stroke="#64748B"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default DirectionHorizontal;
